module.exports = __webpack_public_path__ + "img/share-link.aa5431f1.png";